module.exports = new __parcel__URL__("hamburger_icon.1bad1783.png").toString();